import {Navigate, createBrowserRouter} from "react-router-dom";

import {AuthGate} from "@/components/auth-gate.tsx";
import {Layout} from "@/components/layout.tsx";
import {RouteErrorBoundary} from "@/components/route-error-boundary.tsx";

import {AdminLogin} from "@/pages/admin/admin-login.tsx";
import {AdminDashboard} from "@/pages/admin/admin-dashboard.tsx";
import {AdminLairs} from "@/pages/admin/admin-lairs.tsx";
import {AdminOrgs} from "@/pages/admin/admin-orgs.tsx";
import {AdminOrgApiKeys} from "@/pages/admin/admin-org-api-keys.tsx";
import {AdminPlans} from "@/pages/admin/admin-plans.tsx";
import {AdminPlatformApiKeys} from "@/pages/admin/admin-platform-api-keys.tsx";
import {AdminOSImages} from "@/pages/admin/admin-os-images.tsx";

import {DocsPage} from "@/pages/docs/docspage.tsx";

import {PlansList} from "@/pages/customer/plans-list.tsx";
import {ServerDetail} from "@/pages/customer/server-detail.tsx";
import {ServerNew} from "@/pages/customer/server-new.tsx";
import {ServersList} from "@/pages/customer/servers-list.tsx";

import {LoginRoute} from "@/routes/login-route.tsx";
import {RegisterRoute} from "@/routes/register-route.tsx";

export const router = createBrowserRouter([
  {
    errorElement: <RouteErrorBoundary />,
    children: [
      // ---- public ----
      {path: "/", element: <Navigate to="/servers" replace />},
      {path: "/login", element: <LoginRoute />, handle: {title: "Sign in"}},
      {path: "/register", element: <RegisterRoute />, handle: {title: "Sign up"}},
      {path: "/admin/login", element: <AdminLogin />, handle: {title: "Admin sign in"}},
      {path: "/docs", element: <DocsPage />, handle: {title: "API documentation"}},

      // ---- customer (any signed-in principal) ----
      {
        element: <AuthGate />,
        children: [
          {
            element: <Layout />,
            children: [
              {path: "/servers", element: <ServersList />, handle: {title: "Servers"}},
              {path: "/servers/new", element: <ServerNew />, handle: {title: "Create server"}},
              {path: "/servers/:id", element: <ServerDetail />, handle: {title: "Server"}},
              {path: "/plans", element: <PlansList />, handle: {title: "Plans"}},
            ],
          },
        ],
      },

      // ---- admin only ----
      {
        element: <AuthGate role="account" />,
        children: [
          {
            element: <Layout />,
            children: [
              {path: "/admin", element: <AdminDashboard />, handle: {title: "Admin"}},
              {path: "/admin/lairs", element: <AdminLairs />, handle: {title: "Lairs"}},
              {path: "/admin/plans", element: <AdminPlans />, handle: {title: "Plans"}},
              {
                path: "/admin/os-images",
                element: <AdminOSImages />,
                handle: {title: "OS Images"},
              },
              {path: "/admin/orgs", element: <AdminOrgs />, handle: {title: "Organizations"}},
              {
                path: "/admin/orgs/:id/api-keys",
                element: <AdminOrgApiKeys />,
                handle: {title: "Org API keys"},
              },
              {
                path: "/admin/api-keys",
                element: <AdminPlatformApiKeys />,
                handle: {title: "Platform API keys"},
              },
            ],
          },
        ],
      },
    ],
  },
]);
